/**
 * Builds a wa.me URL ensuring the Italian country code (39) is always present.
 * Without it, WhatsApp's wa.me service may misinterpret the country from the
 * number prefix (e.g. "34" as Spain) and produce a wrong number.
 *
 * Handles:
 *  - "340 18 14 777"   → wa.me/393401814777
 *  - "+393401814777"   → wa.me/393401814777  (already international, kept as-is)
 *  - "0110601429"      → wa.me/390110601429  (landline used on WhatsApp Business)
 */
export const buildTelUrl = (phone) => {
  if (!phone) return null
  const digits = phone.replace(/\D/g, '')
  return digits ? `tel:${digits}` : null
}

export const buildWaMeUrl = (phone) => {
  if (!phone) return null
  const digits = phone.replace(/\D/g, '')
  if (!digits) return null
  const normalized = (digits.startsWith('39') && digits.length >= 11)
    ? digits
    : `39${digits}`
  return `https://wa.me/${normalized}`
}
